import React from 'react';
import ScrollReveal from '../Animation/ScrollReveal';
import StaggerReveal from '../Animation/StaggerReveal';
import './TechnologiesSection.css';

const TechnologiesSection: React.FC = () => {
  const technologies = [
    {
      name: 'React',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2v20M12 2C10 4 6 6 2 6M12 2c2 2 6 4 10 4M12 22c-2-2-6-4-10-4M12 22c2-2 6-4 10-4M2 6v12c0 2 2 4 4 4M22 6v12c0 2-2 4-4 4" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Frontend',
      description: 'Building dynamic user interfaces with React and modern hooks.',
    },
    {
      name: 'Angular',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L3 7l3 10 6 5 6-5 3-10-9-5z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M12 2v20M3 7h18M6 17l6 5 6-5" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Frontend',
      description: 'Enterprise-grade applications with Angular framework.',
    },
    {
      name: 'Vue.js',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L2 22h20L12 2z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M12 6L8 14h8l-4-8z" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Frontend',
      description: 'Progressive JavaScript framework for modern web apps.',
    },
    {
      name: 'Django',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2v20M2 12h20" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Backend',
      description: 'High-level Python web framework for rapid development.',
    },
    {
      name: 'Node.js',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Backend',
      description: 'JavaScript runtime for scalable server-side applications.',
    },
    {
      name: 'Python',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M2 12l10 5 10-5" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Backend',
      description: 'Versatile programming language for AI and web development.',
    },
    {
      name: 'Java',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 2h8l4 4v12l-4 4H8l-4-4V6l4-4z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M8 8h8M8 12h6M8 16h4" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Backend',
      description: 'Enterprise-grade Java development for robust applications.',
    },
    {
      name: 'Spring Boot',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Backend',
      description: 'Java framework for building microservices and enterprise apps.',
    },
    {
      name: 'Laravel',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 4v16h16V4H4z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M8 8h8M8 12h6M8 16h4" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Backend',
      description: 'PHP framework for elegant and efficient web applications.',
    },
    {
      name: 'PostgreSQL',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="12" cy="12" rx="10" ry="4" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M2 12v5c0 2 4 4 10 4s10-2 10-4v-5" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Database',
      description: 'Advanced open-source relational database system.',
    },
    {
      name: 'MongoDB',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2v20M2 12h20" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Database',
      description: 'NoSQL database for modern applications.',
    },
    {
      name: 'MySQL',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 4h16v16H4V4z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M8 8h8M8 12h6M8 16h4" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Database',
      description: 'Popular open-source relational database management system.',
    },
    {
      name: 'SQLite',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 3h18v18H3V3z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M7 7h10M7 12h8M7 17h6" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Database',
      description: 'Lightweight embedded SQL database for mobile and desktop apps.',
    },
    {
      name: 'AWS',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Cloud',
      description: 'Cloud computing services for scalable infrastructure.',
    },
    {
      name: 'VPS Servers',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M8 12h8M12 8v8" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="12" cy="12" r="1" fill="currentColor"/>
        </svg>
      ),
      category: 'Cloud',
      description: 'Virtual Private Servers for dedicated hosting and control.',
    },
    {
      name: 'Docker',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 16h16c2 0 4-2 4-4s-2-4-4-4c-1 0-2 1-3 1" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M8 8V4M12 8V4M16 8V4" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'DevOps',
      description: 'Containerization platform for consistent deployment.',
    },
    {
      name: 'Kubernetes',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M12 5v2M12 17v2M5 12h2M17 12h2M7.05 7.05l1.41 1.41M15.54 15.54l1.41 1.41M7.05 16.95l1.41-1.41M15.54 8.46l1.41-1.41" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'DevOps',
      description: 'Container orchestration for microservices.',
    },
    {
      name: 'React Native',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="2" width="14" height="20" rx="2" ry="2" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="12" y1="18" x2="12" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      category: 'Mobile',
      description: 'Cross-platform mobile app development with React Native.',
    },
    {
      name: 'Flutter',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 3h14v18H5V3z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M9 7h6M9 11h4M9 15h6" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Mobile',
      description: 'Google\'s UI toolkit for building natively compiled apps.',
    },
    {
      name: 'Swift',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 4h16v16H4V4z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M8 8h8M8 12h6M8 16h4" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      category: 'Mobile',
      description: 'iOS app development with Swift programming language.',
    },
  ];

  const categories = ['All', 'Frontend', 'Backend', 'Database', 'Cloud', 'DevOps', 'Mobile'];
  const [activeCategory, setActiveCategory] = React.useState('All');

  const filteredTechnologies = activeCategory === 'All' 
    ? technologies 
    : technologies.filter(tech => tech.category === activeCategory);

  return (
    <section id="technologies" className="technologies-section">
      <div className="technologies-container">
        <ScrollReveal direction="up" duration={0.6}>
          <div className="technologies-header">
            <h2 className="technologies-title">Technologies We Use</h2>
            <p className="technologies-subtitle">
              Leveraging cutting-edge technologies to deliver exceptional solutions
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" duration={0.6} delay={0.1}>
          <div className="category-filters">
            {categories.map(category => (
              <button
                key={category}
                className={`category-btn ${activeCategory === category ? 'active' : ''}`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </ScrollReveal>

        <StaggerReveal staggerDelay={0.05} duration={0.4}>
          <div className="technologies-grid">
            {filteredTechnologies.map((tech, index) => (
              <div key={index} className="tech-item">
                <div className="tech-icon">{tech.icon}</div>
                <div className="tech-content">
                  <h3 className="tech-name">{tech.name}</h3>
                  <p className="tech-description">{tech.description}</p>
                  <span className="tech-category">{tech.category}</span>
                </div>
              </div>
            ))}
          </div>
        </StaggerReveal>
      </div>
    </section>
  );
};

export default TechnologiesSection;